import isEqual from 'lodash/isEqual';
import size from 'lodash/size';
import * as React from 'react';
import { LabelProps } from 'recharts';
import styled from 'styled-components';

interface IExternal {
  external: {
    inverse?: boolean;
    vertical?: boolean;
  };
}

export const LabelWithBackground = (
  props: LabelProps & IExternal
): React.ReactElement => {
  return <LabelContent {...props} />;
};

interface IDimensions {
  height: number;
  width: number;
}

const LabelContent = (props: LabelProps & IExternal): React.ReactElement => {
  const [dimensions, setDimensions] = React.useState<IDimensions>({
    height: 0,
    width: 0,
  });
  const labelRef = React.useCallback((node: SVGTextElement): void => {
    if (node) {
      setDimensions({
        width: node.getBBox().width,
        height: node.getBBox().height,
      });
    }
  }, []);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const vBoxX = (props.viewBox as any).x as number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const vBoxY = (props.viewBox as any).y as number;
  const x = props?.external?.vertical ? vBoxX + 10 : vBoxX - 10;
  const y = props?.external?.vertical
    ? vBoxY - (dimensions.height + 10)
    : vBoxY + 10;

  const width = props?.external?.vertical
    ? dimensions.width + 6
    : dimensions.width + 24;

  const height = props?.external?.vertical
    ? dimensions.height + 15
    : dimensions.height + 6;

  return (
    <React.Fragment>
      <foreignObject
        height={height}
        width={width}
        x={x}
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        y={y}
        xmlns='http://www.w3.org/1999/xhtml'
      >
        {!props.external?.vertical ? (
          <HorizontalOuterContainer>
            <HorizontalContainer>{props.value}</HorizontalContainer>
          </HorizontalOuterContainer>
        ) : (
          <VerticalOuterContainer>
            <VerticalContainer {...dimensions}>{props.value}</VerticalContainer>
          </VerticalOuterContainer>
        )}
      </foreignObject>
      <text ref={labelRef}>{props.value}</text>
    </React.Fragment>
  );
};

const HiddenLabel = (props: {
  text: string | number;
  ref: React.Ref<SVGTextElement>;
}): React.ReactElement => {
  return;
};

const HorizontalOuterContainer = styled.div`
  height: 100%;
  width: 100%;
  padding-left: 15px;
`;

const HorizontalContainer = styled.div<{ inverse?: boolean }>`
  position: relative;
  padding: 3px;
  border-radius: 5px;
  text-align: center;
  background: ${(props: { inverse?: boolean }): string =>
    props?.inverse ? 'var(--color-surface-6)' : 'var(--color-primary)'};
  &:after {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    width: 0;
    height: 0;
    border: 10px solid transparent;
    border-right-color: var(--color-primary);
    border-left: 0;
    margin-top: -10px;
    margin-left: -5px;
  }
`;

const VerticalOuterContainer = styled.div`
  height: 100%;
  width: 100%;
  padding-bottom: 15px;
`;

const VerticalContainer = styled.div<IDimensions & { inverse?: boolean }>`
  position: relative;
  padding: 3px;
  border-radius: 5px;
  text-align: center;

  background: ${(props: { inverse?: boolean }): string =>
    props?.inverse ? 'var(--color-surface-6)' : 'var(--color-primary)'};
  &:after {
    content: '';
    position: absolute;
    left: 50%;
    bottom: 0;
    width: 0;
    height: 0;
    border: 10px solid transparent;
    border-top-color: var(--color-primary);
    border-bottom: 0;
    margin-left: -10px;
    margin-bottom: -5px;
  }
`;
